/* UCNY rush upgrade. One optional service per cart; Zapiet retains scheduling control. */
(function () {
  'use strict';
  if (window.UCRush) return;
  const configNode = document.getElementById('uc-rush-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const ids = new Set(config.variants.map(v => String(v.id)));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let panel, form, busy = false, replay = false, liveMethod = '', zapietBound = false;
  let dirty = false, lastCart = null;

  const rushLines = cart => cart.items.filter(i => ids.has(String(i.variant_id)));
  const excluded = item => /subscription|membership|installation|oversiz|balloon decor|balloon arch|balloon wall|balloon backdrop|balloon column|balloon hoop/i.test((item.product_type || '') + ' ' + (item.product_title || item.title || ''));
  const validGoods = cart => cart.items.some(i => i.requires_shipping && !i.gift_card && !excluded(i) && !i.selling_plan_allocation);
  const incompatible = cart => cart.items.some(i => i.selling_plan_allocation || (i.requires_shipping && excluded(i)));
  const select = () => panel && panel.querySelector('[data-rush-speed]');
  const ack = () => panel && panel.querySelector('[data-rush-ack]');
  function message(text) {
    if (panel) panel.querySelector('[data-rush-status]').textContent = text;
  }
  async function api(path, body) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(root + path, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: body ? JSON.stringify(body) : undefined, signal: controller.signal
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'The cart could not be updated. Please try again.');
      return result;
    } finally { clearTimeout(timer); }
  }
  function today() {
    const p = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    const get = type => p.find(part => part.type === type).value;
    return get('year') + '-' + get('month') + '-' + get('day');
  }
  function showSelection() {
    if (!panel) return;
    const selected = !!select().value;
    panel.querySelector('[data-rush-consent]').hidden = !selected;
    panel.querySelector('[data-rush-product-help]').hidden = !form || !selected;
  }
  function sync(cart) {
    lastCart = cart;
    const lines = rushLines(cart);
    document.documentElement.classList.toggle('uc-rush-in-cart', lines.length > 0);
    if (panel && !dirty) {
      select().value = lines.length ? String(lines[0].variant_id) : '';
      ack().checked = lines.length > 0;
      showSelection();
    }
  }
  function desired() {
    const value = select() ? select().value : '';
    if (value && !ids.has(value)) throw new Error('Please choose a valid rush option.');
    if (value && !ack().checked) throw new Error('Please acknowledge that timing requires store confirmation and normal delivery is charged separately.');
    return value;
  }
  function validateRequest(cart, addingGoods) {
    const method = liveMethod || (cart.attributes || {})['Checkout-Method'];
    if (method === 'pickup' || method === 'shipping') throw new Error('Rush is for local delivery only. Select local delivery in your cart first.');
    if (incompatible(cart)) throw new Error('This cart needs a custom delivery quote or includes a subscription. Please contact the store instead of adding rush.');
    if (!addingGoods && !validGoods(cart)) throw new Error('Add your flowers or eligible gift to the cart before adding a rush upgrade.');
  }
  async function setRush(cart, value) {
    const lines = rushLines(cart), updates = {};
    let kept = false;
    lines.forEach(line => {
      const keep = !kept && value && String(line.variant_id) === value;
      if (keep) kept = true;
      const quantity = keep ? 1 : 0;
      if (line.quantity !== quantity) updates[line.key] = quantity;
    });
    if (value && !kept) updates[value] = 1;
    if (Object.keys(updates).length) cart = await api('cart/update.js', { updates });
    sync(cart);
    return cart;
  }
  async function prepareItems(currentForm, items) {
    if (!panel || currentForm !== form) return items;
    if (busy) throw new Error('Please wait for the current cart update to finish.');
    busy = true;
    try {
      const cart = await api('cart.js');
      sync(cart);
      const value = desired();
      if (!value) {
        if (rushLines(cart).length) await setRush(cart, '');
        return items;
      }
      if (items.some(i => i.selling_plan)) throw new Error('Rush upgrades are not available with subscription purchases.');
      validateRequest(cart, true);
      const lines = rushLines(cart);
      if (lines.length) {
        if (!validGoods(cart)) await setRush(cart, '');
        else { await setRush(cart, value); return items; }
      }
      document.documentElement.classList.add('uc-rush-in-cart');
      return items.concat([{ id: Number(value), quantity: 1, properties: {
        'Rush terms': 'Store confirmation required; normal delivery fee is separate',
        '_uc_rush_upgrade': '1'
      } }]);
    } finally { busy = false; }
  }
  async function saveCart() {
    if (busy) return;
    busy = true;
    const button = panel.querySelector('[data-rush-save]');
    button.disabled = true;
    try {
      const value = desired(), cart = await api('cart.js');
      if (value) validateRequest(cart, false);
      await setRush(cart, value);
      message('Rush selection saved. Refreshing your cart; confirm your delivery date and time before checkout.');
      window.location.reload();
    } catch (error) {
      message(error.message || 'Please try again.');
      button.disabled = false;
    } finally { busy = false; }
  }
  function checkoutError(cart) {
    const lines = rushLines(cart);
    if (!lines.length) return '';
    if (!validGoods(cart) || incompatible(cart)) return 'Rush requires eligible goods for local delivery. Remove rush or contact the store for a custom quote.';
    if ((liveMethod || (cart.attributes || {})['Checkout-Method']) !== 'delivery') return 'Choose local delivery in Zapiet, or remove the rush upgrade before checkout.';
    if ((cart.attributes || {})['Delivery-Date'] !== today()) return 'Rush is for delivery today. Select an available date for today in Zapiet, or remove the rush upgrade.';
    if (lines.length !== 1 || lines[0].quantity !== 1) return 'Keep one rush upgrade per order. Save your preferred option in the rush panel to correct this.';
    return '';
  }
  async function guard(event) {
    if (replay || event.defaultPrevented) return;
    let target;
    if (event.type === 'click') target = event.target.closest('button[name="checkout"],input[name="checkout"],a[href="/checkout"],a[href^="/checkout?"]');
    else if (event.target instanceof HTMLFormElement && (event.submitter && event.submitter.name === 'checkout' || /\/checkout(?:\?|$)/.test(event.target.action))) target = event.target;
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) { message('Please wait for the cart update to finish.'); return; }
    try {
      const cart = await api('cart.js');
      sync(cart);
      const error = checkoutError(cart);
      if (error) {
        if (panel) { message(error); panel.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        else { window.location.href = root + 'cart#uc-rush-panel'; }
        return;
      }
      replay = true;
      try {
        if (event.type === 'click') target.click();
        else if (event.submitter) target.requestSubmit(event.submitter);
        else target.requestSubmit();
      } finally { replay = false; }
    } catch (error) {
      if (panel) message('Please check your cart before checkout. ' + error.message);
      else window.location.href = root + 'cart';
    }
  }
  function connectZapiet() {
    if (zapietBound || !window.ZapietEvent || typeof window.ZapietEvent.listen !== 'function') return;
    zapietBound = true;
    window.ZapietEvent.listen('selected_method', method => {
      liveMethod = method;
      if (method !== 'delivery' && lastCart && rushLines(lastCart).length) message('Rush is only for local delivery. Choose local delivery or select Standard and save to remove rush.');
    });
  }
  function mount() {
    if (document.getElementById('uc-rush-panel')) return;
    let target = null;
    if (config.eligibleProduct) {
      const productIds = new Set(config.productVariants.map(String));
      form = Array.from(document.querySelectorAll('product-form form')).find(f => productIds.has(String(new FormData(f).get('id'))));
      if (!form) return;
      target = form.closest('product-form') || form;
    } else if (config.pageType === 'cart') target = document.getElementById('cart-footer-form');
    if (!target) return;
    const template = document.getElementById('uc-rush-template');
    const content = template.content.cloneNode(true);
    panel = content.querySelector('[data-rush-panel]');
    if (form) target.after(content); else target.before(content);
    panel.querySelector('[data-rush-save]').hidden = !!form;
    select().addEventListener('change', () => { dirty = true; ack().checked = false; showSelection(); message(''); });
    panel.querySelector('[data-rush-save]').addEventListener('click', saveCart);
    showSelection();
    api('cart.js').then(sync).catch(() => message('Your cart will be checked when you add or update rush.'));
  }
  window.UCRush = { prepareItems, showError: error => message(error.message || String(error)) };
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
  function start() { mount(); connectZapiet(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
  let attempts = 0;
  const timer = setInterval(() => { start(); if (++attempts >= 20) clearInterval(timer); }, 500);
}());
